module.exports = "/static/assets/2258ea6dfe9ad15440ca55aca291698d.svg";